import { create } from "zustand";

interface DarkModeStore {
  darkMode: boolean;
  setDarkMode: (darkMode: boolean) => void;
}

// Initialize Zustand store with localStorage persistence
export const useDarkModeStore = create<DarkModeStore>((set) => {
  // Retrieve saved value from localStorage, default to false if not set
  const savedDarkMode = localStorage.getItem("darkMode") === "true";

  return {
    darkMode: savedDarkMode,
    setDarkMode: (darkMode) => {
      set({ darkMode });
      localStorage.setItem("darkMode", JSON.stringify(darkMode)); // Save to localStorage
    },
  };
});
